export default __webpack_public_path__ + "static/media/translations.2b97ec41.csv";